module.exports = __webpack_public_path__ + "static/media/YM43_5.2b930586.jpg";